import { render, staticRenderFns } from "./exam-score-list.vue?vue&type=template&id=ca7ffd7a&scoped=true"
import script from "./exam-score-list.vue?vue&type=script&lang=ts"
export * from "./exam-score-list.vue?vue&type=script&lang=ts"
import style0 from "./exam-score-list.vue?vue&type=style&index=0&id=ca7ffd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7ffd7a",
  null
  
)

export default component.exports